import MinAccWeightInput from './MinAccWeightInput';

export default MinAccWeightInput;
